import { faPen, faPrint, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Component } from "react";
import { CommonValidationMessages } from "../../utils/Messages.js";
import { isValidForm } from "../../utils/validation/CommonValidator.js";
import ValidationText from "../../utils/validation/ValidationText.js";

class WeighingSlipPrint extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterDetails: {
        slipNo: "",
        productName: "",
        filterBy: "",
      },
      filterByList: [
        { filterBy: "Slip No.", value: "slipNo" },
        { filterBy: "Batch No", value: "batchNo" },
        { filterBy: "Batch Size", value: "batchSize" },
      ],
      validationRules: {
        slipNo: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "slip no"
            ),
          },
        ],
        productName: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "product name"
            ),
          },
        ],
      },
      validState: {
        isValid: true,
        error: {},
      },
    };
  }

  isAllFieldsValidate = () => {
    const newValidState = isValidForm(
      this.state.filterDetails,
      this.state.validationRules,
      this.state.validState
    );
    this.setState({ validState: newValidState });
    return newValidState.isValid;
  };

  handleChange = (event, name, section) => {
    let value = event.target.value;
    if (section === "filterDetails") {
      let details = this.state.filterDetails;
      details[name] = value.toUpperCase();
      this.setState(
        { filterDetails: details }
        //     , () =>
        //      {
        //     this.getAllProductionPlanningEntry();
        //   }
      );
    }
  };
  handleDropDownChange = (event, name) => {
    const select = event.target.value;
    if (select !== "Select") {
      let details = this.state.filterDetails;
      details[name] = select;
      this.setState(
        { filterDetails: details }
        //     , () => {
        //     this.getAllProductionPlanningEntry();
        //   }
      );
    }
  };

  render() {
    return (
      <div className="weighingSlipPrint-page">
        <div className="item-search">
          <div className="item-grp flex gap-[10px] mb-2.5">
            <div className="search-grp w-1/5">
              <label>Slip No.</label>
              <input
                type="text"
                id="slipNo"
                name="slipNo"
                className="inputFocus w-full"
                value={this.state.filterDetails.slipNo}
                onChange={(event) =>
                  this.handleChange(event, "slipNo", "filterDetails")
                }
              />
              <ValidationText error={this.state.validState.error.slipNo} />
            </div>
            <div className="search-grp w-3/5">
              <label>Product Name</label>
              <input
                type="text"
                id="productName"
                name="productName"
                className="inputFocus w-full"
                value={this.state.filterDetails.productName}
                onChange={(event) =>
                  this.handleChange(event, "productName", "filterDetails")
                }
              />
              <ValidationText error={this.state.validState.error.productName} />
            </div>
            <div className="search-grp w-1/5">
              <label>Arranged By:</label>
              <select
                name="filterBy"
                className="w-full"
                value={this.state.filterDetails.filterBy}
                onChange={(event) =>
                  this.handleDropDownChange(event, "filterBy", "filterDetails")
                }
              >
                <option>Select</option>
                {this.state.filterByList.map((x, key) => (
                  <option key={key} value={x.value}>
                    {x.filterBy}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <button className="add-btn">Search</button>
        </div>
        <div className="itemList-table">
          <div className="table-container">
            <table className="itemList">
              <thead>
                <tr>
                  <td style={{ width: "30%" }}>Product Name</td>
                  <td style={{ width: "10%" }}>Batch No.</td>
                  <td style={{ width: "10%" }}>Bt. Size</td>
                  <td style={{ width: "10%" }}>Mfg. Date</td>
                  <td style={{ width: "10%" }}>Exp. Dt.</td>
                  <td style={{ width: "10%", textAlign: "center" }}>Action</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Sanitash software modules</td>
                  <td>SS001235</td>
                  <td>500000</td>
                  <td>30/09/9999</td>
                  <td>30/09/9999</td>
                  <td style={{ textAlign: "center" }}>
                    <button
                      className="print-btn"
                    //   onClick={() => }
                    >
                      <FontAwesomeIcon icon={faPrint} />
                    </button>
                  </td>
                </tr>
              </tbody>
              <tbody className="validation-body">
                <tr>
                  <td
                    colSpan={9}
                    style={{ textAlign: "center", fontSize: "16px" }}
                  >
                    No Records Found
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

export default WeighingSlipPrint;
